(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maneo-card-photos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maneo-card-photos')) {
  customElements.define('maneo-card-photos', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.mc-photos__track');
      this.slides = [...this.querySelectorAll('.mc-photos__slide')];
      this.dots = [...this.querySelectorAll('[data-photo-index]')];
      this.index = 0;
      this.suppressUntil = 0;
      if (!this.track || !this.slides.length) return;
      this.addEventListener('click', event => {
        const dot = event.target.closest('[data-photo-index]');
        if (dot) { event.preventDefault(); this.go(Number(dot.dataset.photoIndex)); }
        else if (Date.now() < this.suppressUntil) { event.preventDefault(); event.stopPropagation(); }
      }, { signal, capture: true });
      this.track.addEventListener('pointerdown', event => {
        this.suppressUntil = 0;
        this.start = { x: event.clientX, y: event.clientY, scroll: this.track.scrollLeft };
        this.moved = false;
      }, { signal, passive: true });
      this.track.addEventListener('pointermove', event => {
        if (this.start && Math.hypot(event.clientX - this.start.x, event.clientY - this.start.y) > 8) this.moved = true;
      }, { signal, passive: true });
      const finish = () => {
        if (this.start && (this.moved || Math.abs(this.track.scrollLeft - this.start.scroll) > 8)) this.suppressUntil = Date.now() + 500;
        this.start = null;
      };
      this.track.addEventListener('pointerup', finish, { signal, passive: true });
      this.track.addEventListener('pointercancel', finish, { signal, passive: true });
      this.track.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault(); event.stopPropagation();
        this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          if (this.track.clientWidth) this.select(Math.round(Math.abs(this.track.scrollLeft) / this.track.clientWidth));
        });
      }, { signal, passive: true });
      this.observer = new ResizeObserver(() => {
        if (this.track.clientWidth) this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'instant' });
      });
      this.observer.observe(this.track);
      this.select(0);
    }
    select(index) {
      this.index = Math.max(0, Math.min(index, this.slides.length - 1));
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.slides.forEach((slide, i) => { slide.tabIndex = i === this.index ? 0 : -1; });
    }
    go(index) {
      const next = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() { this.abort?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["maneo-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('maneo-gallery')) customElements.define('maneo-gallery',class extends HTMLElement {
  connectedCallback(){
    if(this.ready)return;this.ready=true;this.controller=new AbortController();const opts={signal:this.controller.signal};
    this.rail=this.querySelector('.mg-rail');this.slides=Array.from(this.querySelectorAll('.mg-slide'));this.thumbs=Array.from(this.querySelectorAll('[data-thumb]'));this.dialog=this.querySelector('dialog');this.index=0;
    this.addEventListener('click',e=>{
      const thumb=e.target.closest('[data-thumb]');if(thumb)this.go(Number(thumb.dataset.thumb));
      if(e.target.closest('[data-prev]'))this.go(this.index-1);if(e.target.closest('[data-next]'))this.go(this.index+1);
      const play=e.target.closest('[data-play]');if(play){const slide=play.closest('.mg-slide');if(!slide.querySelector('iframe'))slide.append(slide.querySelector('template').content.cloneNode(true));play.hidden=true;}
      const zoom=e.target.closest('[data-zoom]');if(zoom){this.zoomOpener=zoom;const img=zoom.querySelector('img').cloneNode();img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=zoom.dataset.full;img.loading='eager';this.querySelector('[data-zoom-image]').replaceChildren(img);this.dialog.showModal();}
      if(e.target.closest('[data-close]')||e.target===this.dialog)this.dialog.close();
    },opts);
    this.dialog.addEventListener('close',()=>this.zoomOpener?.focus({preventScroll:true}),opts);
    this.rail.addEventListener('keydown',e=>{if(e.target!==this.rail)return;if(e.key==='ArrowRight'){e.preventDefault();this.go(this.index+1)}if(e.key==='ArrowLeft'){e.preventDefault();this.go(this.index-1)}},opts);
    this.observer=new IntersectionObserver(entries=>{for(const entry of entries)if(entry.isIntersecting&&entry.intersectionRatio>.6)this.select(this.slides.indexOf(entry.target));},{root:this.rail,threshold:.65});this.slides.forEach(slide=>this.observer.observe(slide));this.select(0);
  }
  go(index){index=Math.max(0,Math.min(index,this.slides.length-1));this.rail.scrollTo({left:index*this.rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});this.select(index);}
  select(index){if(index<0)return;this.index=index;this.thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===index)));this.querySelector('[data-count]').textContent=(index+1)+' / '+this.slides.length;this.querySelector('[data-prev]').disabled=index===0;this.querySelector('[data-next]').disabled=index===this.slides.length-1;const thumb=this.thumbs[index];if(thumb){const row=thumb.parentElement;if(thumb.offsetLeft<row.scrollLeft||thumb.offsetLeft+thumb.offsetWidth>row.scrollLeft+row.clientWidth)row.scrollTo({left:thumb.offsetLeft-row.clientWidth/2,behavior:'smooth'});}this.slides.forEach((slide,i)=>{if(i===index)return;slide.querySelectorAll('video').forEach(video=>video.pause());slide.querySelectorAll('iframe').forEach(frame=>frame.remove());const play=slide.querySelector('[data-play]');if(play)play.hidden=false;});}
  disconnectedCallback(){this.observer?.disconnect();this.controller?.abort();this.ready=false;}
});
  } catch(e) { console.error(e); }
})();

})();
